import PhotoGrid from "components/common/PhotoGrid"
import PropTypes from "prop-types"
import { useState } from "react"
import { VideoPlayerModal } from "ui/VideoPlayerModal"
import { isMediaFileVideo } from "utils/media-upload"

export const PreviewMediaListing = ({ trip }) => {
  const [videoModalOpen, setVideoModalOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(null)

  const { photos, videos } = trip
  const media = [...(photos || []), ...(videos || [])]

  const handleMediaClick = (media) => {
    if (isMediaFileVideo(media)) {
      setSelectedMedia(media)
      setVideoModalOpen(true)
    }
  }

  const handleCloseVideoModal = () => {
    setVideoModalOpen(false)
    setSelectedMedia(null)
  }

  return (
    <div>
      <PhotoGrid photos={media} handleMediaClick={handleMediaClick} />
      <VideoPlayerModal open={videoModalOpen} handleClose={handleCloseVideoModal} selectedMedia={selectedMedia} />
    </div>
  )
}

// ✅ Add prop validation here
PreviewMediaListing.propTypes = {
  trip: PropTypes.shape({
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string
      })
    ),
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        type: PropTypes.string // assuming video type (e.g., "video/mp4")
      })
    )
  }).isRequired
}
